import { useState,useEffect, useMemo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Divider, Grid, TextField, Typography, useTheme } from '@mui/material';
import { ButtonBasic, SelectTipoEquipamiento } from '../../components';
import ArticuloFallaTkService from '../../services/articuloFallaTk.service';
import EquipamientoTkService from '../../services/equipamiento-ticket.service';

const ModalAddEquipamientoServicio = ({
    show,
    hideModal,
    item,
    onGuardar,
    ticketId,
    servicioId,
    onGuardar2
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isLoading, setIsLoading] = useState(false);
    const handleClose = () => hideModal();
    const [formAll, setFormAll] = useState({
        snEquipo_eqt: {
            texto: null,
            textoErr: 'El SN es requerida',
            estadoErr: false,
            tipo: 'string'
        },
        macEquipo_eqt: {
            texto: null,
            textoErr: 'La mac es requerida',
            estadoErr: false,
            tipo: 'string'
        },
        movimientoEquipo_eqt: {
            texto: null,
            textoErr: 'El movimiento es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        tipoEquipo_eqt: {
            texto: null,
            textoErr: 'El tipo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        codigoUnicoEquipo_eqt: {
            texto: null,
            textoErr: 'El codigo unico es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        codigoEquipo_eqt: {
            texto: null,
            textoErr: 'El codigo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        nombreEquipo_eqt: {
            texto: null,
            textoErr: 'El nombre es requerido',
            estadoErr: false,
            tipo: 'string'
        },
    });
    const onChangeForm = (value,input) =>{
        let formOld = formAll;
        if(!formOld[input]){
            formOld[input] = {
                texto: value,
                textoErr: `El ${input} es requerido`,
                estadoErr: false,
                tipo: 'string'
            }
        }else{
            formOld[input].texto = value
        }
        if((!value || value === '') && input !== 'telefono_c'){
            formOld[input].estadoErr = true
        }else{
            formOld[input].estadoErr = false;
        }
        setFormAll({...formOld})
    }
    const onChangeFormSetError = (input,clear) =>{
        let formOld = formAll;
        formOld[input].estadoErr = !clear ? true : false
        setFormAll({...formOld})
    }
    const onSubmit = async() => {
        const form = {ticketId_eqt: ticketId,servicioId_eqt: servicioId};
        let isOk = false;
        setIsLoading(true);
        const inputRequired = ['movimientoEquipo_eqt']
        const propertyNames = Object.keys(formAll);
        await Promise.resolve(
        propertyNames.forEach((name)=>{
        if(formAll[name]?.texto && formAll[name]?.texto !== '' && !formAll[name]?.estadoErr){
            form[name] = formAll[name].texto
        }else{
            if(inputRequired.includes(name)){
                isOk = true;
                onChangeFormSetError(name)
            }
        }
        }))
        if(!isOk){
            if(item?.id_eqt > 0) {
                form.id_eqt = item.id_eqt
                await EquipamientoTkService.update(form)
                    .then(() => {
                        onGuardar();
                        if(onGuardar2){
                            onGuardar2();
                        }
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }else{
                await EquipamientoTkService.register(form)
                    .then(() => {
                        onGuardar();
                        if(onGuardar2){
                            onGuardar2();
                        }
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }
        }else{
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if(item){
            setTimeout(() => {
                onChangeForm(item?.snEquipo_eqt,'snEquipo_eqt');
                onChangeForm(item?.macEquipo_eqt,'macEquipo_eqt');
                onChangeForm(item?.movimientoEquipo_eqt,'movimientoEquipo_eqt');
                onChangeForm(item?.tipoEquipo_eqt,'tipoEquipo_eqt');
                onChangeForm(item?.codigoUnicoEquipo_eqt,'codigoUnicoEquipo_eqt');
                onChangeForm(item?.codigoEquipo_eqt,'codigoEquipo_eqt');
                onChangeForm(item?.nombreEquipo_eqt,'nombreEquipo_eqt');
            }, 100);
        }
    }, [item])

    const styleInput = useMemo(() => ({
        '& .MuiInputLabel-root':{
            color: isDarkMode ? '#b0bec5' : 'gray',
            fontSize: 14,
            marginTop: -0.4
        },
        '& fieldset': {
            borderRadius: 2,
            height: 50,
            border: 1,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                border:1,
                borderColor: isDarkMode ? '#90caf9' : '#0364ff',
                color: isDarkMode ? '#e0e0e0' : '#000',
                height: 50,
            },
            '&:hover':{
                border: 0.1,
                borderRadius: 2,
                borderColor: isDarkMode ? '#4a5a72' : 'gray',
                height: 45,
            },
            '&.Mui-focused': {
                '&:hover':{
                    border: 0,
                    borderRadius: 2,
                    height: 45,
                }
            },
            color: isDarkMode ? '#e0e0e0' : 'gray',
            height: 45,
        }
    }), [isDarkMode]);

    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='sm' fullWidth sx={{backdropFilter: 'blur(0.4px);'}}>
            <Box sx={{background: isDarkMode ? '#1F2A40' : '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} variant='h5'>
                        {item?.id_atk > 0 ? 'Editar Equipamiento' : 'Registrar Equipamiento'}
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Tipo:</Typography>
                            <SelectTipoEquipamiento
                                value={formAll.codigoUnicoEquipo_eqt.texto}
                                onChange={(e)=>{
                                    onChangeForm(e?.codUnico, 'codigoUnicoEquipo_eqt');
                                    onChangeForm(e?.tipo, 'tipoEquipo_eqt');
                                    onChangeForm(e?.cod_producto, 'codigoEquipo_eqt');
                                    onChangeForm(e.nombre, 'nombreEquipo_eqt');
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>SN:</Typography>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                value={formAll.snEquipo_eqt.texto}
                                error={formAll.snEquipo_eqt.estadoErr}
                                helperText={formAll.snEquipo_eqt.estadoErr && formAll.snEquipo_eqt.textoErr}
                                onChange={(e)=>onChangeForm(e.target.value, 'snEquipo_eqt')}
                                sx={styleInput}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Mac:</Typography>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                value={formAll.macEquipo_eqt.texto}
                                error={formAll.macEquipo_eqt.estadoErr}
                                helperText={formAll.macEquipo_eqt.estadoErr && formAll.macEquipo_eqt.textoErr}
                                onChange={(e)=>onChangeForm(e.target.value, 'macEquipo_eqt')}
                                sx={styleInput}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Movimiento Softland:</Typography>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                value={formAll.movimientoEquipo_eqt.texto}
                                error={formAll.movimientoEquipo_eqt.estadoErr}
                                helperText={formAll.movimientoEquipo_eqt.estadoErr && formAll.movimientoEquipo_eqt.textoErr}
                                onChange={(e)=>onChangeForm(e.target.value, 'movimientoEquipo_eqt')}
                                sx={styleInput}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        isLoading={isLoading}
                    />
                    <ButtonBasic
                        textButton='Guardar'
                        onClick={()=>onSubmit()}
                        isLoading={isLoading}
                        variant='wk'
                        color='nextStep'
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalAddEquipamientoServicio